import { render, staticRenderFns } from "./platform_user_management.vue?vue&type=template&id=8f127c96&scoped=true&"
import script from "./platform_user_management.vue?vue&type=script&lang=js&"
export * from "./platform_user_management.vue?vue&type=script&lang=js&"
import style0 from "./platform_user_management.vue?vue&type=style&index=0&id=8f127c96&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f127c96",
  null
  
)

export default component.exports